import { Injectable } from '@angular/core';
import { PermissionCheckerService } from '../../../node_modules/abp-ng2-module/dist/src/auth/permission-checker.service';
import { AppSessionService } from '../session/app-session.service';

import {
    CanActivate, Router,
    ActivatedRouteSnapshot,
    RouterStateSnapshot,
    CanActivateChild
} from '@angular/router';

@Injectable()
export class AppRouteGuard implements CanActivate, CanActivateChild {

    constructor(
        private _permissionChecker: PermissionCheckerService,
        private _router: Router,
        private _sessionService: AppSessionService,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (!this._sessionService.user) {
            this._router.navigate(['/login']);
            //alert(1);
            return false;
        }

        if (!route.data || !route.data['permission']) {
            //alert(2);
            return true;
        }

        if (this._permissionChecker.isGranted(route.data['permission'])) {
            //alert(3);
            return true;
        }

        //alert(4);
        this._router.navigate([this.selectBestRoute()]);
        //alert(5);
        return false;
    }

    canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.canActivate(route, state);
    }

    selectBestRoute(): string {
        if (!this._sessionService.user) {
            return '/login';
        }

        /*
        if (this._permissionChecker.isGranted('Pages.Users')) {
            return '/app/admin/users';
        }
        */

        //return '/app/dashboard';
        return '/platom/analysis';
    }
}
